import {
  EnumStatusEmbarque,
  EnumStatusEmbarqueString,
  EnumStatusShipmentString,
} from "../../shared/Enumerables";
import { format } from "date-fns";

export const validateEmail = (email) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

export const validateNumbers = (email) => {
  const regex = /^[\d\s]+$/;
  return regex.test(email);
};

export const validateRFCMo = (rfc) => {
  const regex =
    /^([A-ZÑ&]{3}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
  return regex.test(rfc);
};

export const validateRFCFs = (rfc) => {
  const regex =
    /^([A-ZÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
  return regex.test(rfc);
};

export const validateContieneMayusuculas = (text) => {
  text = text ? text : "";
  const regex = /[A-Z]/;
  return text.search(regex) >= 0;
};

export const validateContieneNumeros = (text) => {
  text = text ? text : "";
  const regex = /[0-9]/;
  return text.search(/[0-9]/) >= 0;
};

export const validateContieneCaracteresEspeciales = (text) => {
  text = text ? text : "";
  const regex = /(?=.*[ñÑ\-_¿.#¡!@$%^&*])/;
  return text.search(regex) >= 0;
};

export const getError = (error) => {
  let errors = "";
  if (error.response && error.response.data) {
    if (Array.isArray(error.response.data)) {
      errors = Object.values(error.response.data)
        .flat()
        .map((e) => e + "\n")
        .join("");
    } else if (error.response.data?.responseMessage) {
      errors = error.response.data.responseMessage;
    } else {
      errors = error.response.data;
    }
  } else {
    errors = error.message;
  }
  return errors;
};

export const getColorEstatusEmbarque = (estatus) => {
  let bgChip = "";
  switch (estatus.toUpperCase()) {
    case EnumStatusEmbarqueString.Creado:
      bgChip = "recibido";
      break;
    case EnumStatusEmbarqueString.En_Transito:
      bgChip = "transito"; //"documentado"
      break;
    case EnumStatusEmbarqueString.Entregado:
      bgChip = "entregado"; //"transito"
      break;
    case EnumStatusEmbarqueString.No_Entregado:
      bgChip = "noEntregado";
      break;
    default:
      bgChip = "recibido";
      break;
  }
  return bgChip;
};

export const getColorEstatusEnvio = (estatus) => {
  let bgChip = "";
  switch (estatus.toUpperCase()) {
    case EnumStatusShipmentString.Creado:
      bgChip = "recibido";
      break;
    case EnumStatusShipmentString.En_Transito:
      bgChip = "documentado";
      break;
    case EnumStatusShipmentString.Entregado:
      bgChip = "entregado"; //"transito"
      break;
    case EnumStatusShipmentString.No_Entregado:
      bgChip = "noEntregado";
      break;
    default:
      bgChip = "recibido";
      break;
  }
  return bgChip;
};

export const getFormatDate = (today, formato = "dd/MM/yyyy hh:mm aaa") => {
  if (Date.parse(today)) {
    let fecha = new Date(today);
    return format(fecha, formato);
  } else {
    return "Sin Definir";
  }
};

export const getDayOfWeek = (today) => {
  switch (today.getDay()) {
    case 0:
      return "Domingo";
      break;
    case 1:
      return "Lunes";
      break;
    case 2:
      return "Martes";
      break;
    case 3:
      return "Miércoles";
      break;
    case 4:
      return "Jueves";
      break;
    case 5:
      return "Viernes";
      break;
    case 6:
      return "Sábado";
      break;
    default:
      return "Error";
  }
};

export const blobToBase64 = (blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

export const getOption = (label, value) => {
  return { label, value };
};
